import React, {useState, useEffect, useRef, useMemo} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from "react-toastify";
import {
    getAllFamilies,getPortfoliosByFamily,getInvestorStatus,getassetclassbyType,getshareclassbyType,getAssetLotByPortfolio,getInvestortrackersourcedata, insertorupdateInvestorTracking
} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { AgGridReact } from 'ag-grid-react';
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBAComboBox, SBADropDown, SBAMultiSelect } from '../../UiComponents/SBADropDown';
import CurrencyInput from "react-currency-input-field";
import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import moment from 'moment';
import { SBNotify } from "../../utils/sbNotify";
import { gettrackingdetails } from "../../../config/apiConfig";
import { getCurrencyFormat } from "./InvestorTracking";
import { getcategory } from "../../../config/apiConfig";

export const ITRedemption = () => {
    const Level = [
        { BreadCrumb: "Investor >", Routes: `${UrlPath.Investor}`}, 
        { BreadCrumb: "Tracker >", Routes: `${UrlPath.InvestorTracking}`},
        { BreadCrumb: "Redeem", Routes: `${UrlPath.InvestorTrackingRedemption}`}
    ];
    const params=useParams();
    const [family, setFamily] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [portfolio, setPortfolio] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [status, setStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    


    const [existingStatus, setExistingStatus] = useState(null);


    const [asset, setAsset] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [shareClass, setShareClass] = useState([]);
    const [selectedShareClass, setSelectedShareClass] = useState(null);
    const [lot, setLot] = useState([]);
    const [selectedLots, setSelectedLots] = useState([]);
    const [note, setNote] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileError, setFileError] = useState(null);
    const [liquiditygriddt,setliquiditygriddt]=useState([]);
    const [transactiongriddt,settransactiongriddt]=useState([]);
    const locationData = useLocation(); 
    const groupId = locationData.state !==null? locationData.state.groupId === undefined ? null : locationData.state.groupId:null;
    const mode = locationData.state !==null? locationData.state.mode === undefined ? null : locationData.state.mode:null;
    const [investorTrackingId,setInvestorTrackingId]=useState(params.InvestorTrackingId);
    const gridRef = useRef();
    const navigate = useNavigate();
    const activitySourceId = 2;
    const [documentCategories, setDocumentCategories] = useState([]);
    const [selectedDocumentCategory, setSelectedDocumentCategory] = useState(null);



    const fetchDocumentCategories = async () => {
        try {
            const list = await sbaAxios({
                url: `${getcategory}${activitySourceId}`,
            });
            return list;
            setDocumentCategories(list);
        } catch (e) {
            return [];
            setDocumentCategories([]);
        }
    };
    useEffect(()=>{
        document.title="Redemption Tracking";
        getFamily();
        getStatus();
       // getAssetsBytranstypeId();

       fetchDocumentCategories().then(caterList=>{
        setDocumentCategories(val=>caterList);
       if(params.InvestorTrackingId >0)
        {
            sbaAxios({url:gettrackingdetails+"?investorTrackingId="+params.InvestorTrackingId+"&transactionGroupId="+groupId}).then(res=>{
                    setSelectedAsset({AssetName:res.AssetName,AssetId:res.AssetId});
                    setSelectedFamily({FamilyName:res.FamilyName,FamilyId:res.FamilyId});
                    setSelectedPortfolio({EntityName:res.PortfolioName,EntityId:res.PortfolioId});
                setSelectedShareClass({ ShareClassName: res.ShareClassName, ShareClassId: res.ShareClassid });
                setSelectedStatus({ InvestorTRackingStatusName: res.InvestorTrackingStatusName, InvestorTrackingStatusId: res.InvestorTrackingStatusId})
                setExistingStatus({ InvestorTRackingStatusName: res.InvestorTrackingStatusName, InvestorTrackingStatusId: res.InvestorTrackingStatusId})
       
                setliquiditygriddt(res.DetailTransactions.map(item => {
                        item.RedemptionPercentage=item.TransactionPercentage;
                        item.RedemptionAmount = item.TransactionAmount;
                        item.AvailableAmount = item.TransactionAmount;
                        item.RedemptionDate = item.TransactionDate;
                        item.IsBooked = true;
                        return item;
                    }));
                    if(mode === "Edit"){
                        settransactiongriddt(res?.BookedTransactions);
                    }



                setSelectedFiles(res.Documents.map((item,index) => {
                    item.documentId = item.DocumentId;
                    item.fileName = item.DocumentName;
                    item.base64String = "";
                    item.documentIndex = index
                    return item;
                }));
                setNote(res.Notes);

                const activitySubTypeId = res?.ActivitySubTypeId;
                setSelectedDocumentCategory(() => {
                    const docCategory = caterList.find((item) => item.ActivitySubTypeId === activitySubTypeId);
                    return docCategory;
                })
            }).catch(error => {
                console.log(error, 'error fetching Data for Investor Tracking Details');
            })
       }
    });
    },[]);

    const CheckboxRendererMenu = (props) => {
        const isadd = props.data;
        return (
          <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
                <input type='checkbox'
                    defaultChecked={isadd.IsBooked}
                    disabled={mode !== "Edit" ? isadd.addbooked : true}
                    onChange={(e) => {
                        
                 setliquiditygriddt(val=>(val.map((item,index)=>{
                    if(props.rowIndex==index)
                    {
                        item.IsBooked = e.target.checked;
                        
                    }
                    return item;
            })))

            }} />
    
    
          </div>
        );
      };

    const allowedExtensions = ['pdf'];
    const handleFileChange = (event) => {
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
          const updatedFiles = [...selectedFiles];
          const startingRowIndex = updatedFiles.length; 
        
          for (let i = 0; i < newFiles.length; i++) {
            const file = newFiles[i];
            const fileName = file.name;
            const lastDotIndex = fileName.lastIndexOf('.');
            const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
            // Check if the extension is allowed
            if (!allowedExtensions.includes(extension.toLowerCase())) {
                setFileError(`Unsupported file format: .${extension}`);
                continue; // Skip the rest if the format is invalid
            }
            setFileError("");
            const reader = new FileReader();
            reader.onload = function () {
              if (reader.result) {
                const arrayBuffer = reader.result;
                const base64String = arrayBufferToBase64(arrayBuffer);
                const rowIndex = startingRowIndex + i;        
                updatedFiles.push({ file, fileName, extension, base64String, rowIndex , documentId:0 ,documentIndex:selectedFiles.length});
                setSelectedFiles(updatedFiles);
              }
            };
        
            reader.readAsArrayBuffer(file);
          }
        }
        
    };

      

    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };

    const onCellValueChanged = (params) => {
        const updatedDocuments = selectedFiles.map(doc =>
            doc.id === params.data.id ? { ...doc, DocumentName: params.data.DocumentName } : doc
        );
        setSelectedFiles(updatedDocuments);
    };

    const DeleteButtonRenderer = (props) => {
        const handleDeleteClick = () => {
            const updatedFiles = selectedFiles.filter((item, index) => item.documentIndex !== props.data.documentIndex);
            setSelectedFiles(updatedFiles);
          
        }
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };
   
    const gridValueFormatter = (params) => {
        return params.value;
    };
    const getFormattedDate=(params)=>{
        return params.value ? moment(params.value).format("MM-DD-YYYY") : "";
      };
        const FormatCurrencyGrid = (params) => {
   
        var num = params.value;
    
        if (num !== undefined) {
          // Check if the value is negative
          const isNegative = num < 0;
    
          // Remove negative sign and format with parentheses
          const formattedValue = getCurrencyFormat(num)
        //   isNegative
        //     ? `($${Math.abs(num).toLocaleString('en-US', {
        //       minimumFractionDigits: 0,
        //       maximumFractionDigits: 0
        //     })})`
        //     : `$${num.toLocaleString('en-US', {
        //       minimumFractionDigits: 0,
        //       maximumFractionDigits: 0
        //     })}`;
    
          // Apply red color for negative values
          const style = isNegative ? { color: 'red' } : null;
    
          return <span style={style}>{formattedValue}</span>;
        } else {
          return num;
        }
      };
      const FormatpercentCurrencyGrid = (params) => {

        var num = params.value;
    
        if (num !== undefined && num != null) {
          if (num === 0) {
            num = 0;
          }
          const isNegative = num < 0;
          const formattedValue = isNegative
            ? `${(num).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 4,
            })} %`
            : `${num.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} %`;
          const style = isNegative ? { color: 'red' } : null;
    
          return <span style={style}>{formattedValue}</span>;
    
        } else {
          return <span></span>;
        }
      };
    const percentchangeCalc=(params)=>
    {
               const percent=params.newValue>100?100:params.newValue;

        setliquiditygriddt((prevData) =>
        prevData.map((item) => {        
              if (item.RowIndex === params.data.RowIndex) {
              const amt=  item.AvailableAmount;
                const  RedemptionAmount = amt*percent/100;
              
                return {
                  ...item,
                  RedemptionAmount: RedemptionAmount,
                  RedemptionPercentage:percent
                };
              }
          return item;
        })
      );
    }
    const AmountchangeCalc=(params)=>
    {
               const redemptamt=params.newValue;
               if(investorTrackingId==0)
               {
               if(parseFloat(redemptamt)>parseFloat(params.data.AvailableAmount))
               {
                SBNotify({Msg:"Redemption Amount cannot be greater than Available Amount", type:"error"});
                setliquiditygriddt((prevData) =>
                prevData.map((item) => {        
                      if (item.RowIndex === params.data.RowIndex) {
                        return {
                          ...item,
                          RedemptionAmount: params.data.AvailableAmount,
                          RedemptionPercentage:100
                        };
                      }
                  return item;
                })
              );
               }
               else
               {
        setliquiditygriddt((prevData) =>
        prevData.map((item) => {        
              if (item.RowIndex === params.data.RowIndex) {
              const amt=  item.AvailableAmount;
              const RedemptionPercentage=(redemptamt/amt)*100;
               
                return {
                  ...item,
                  RedemptionAmount: redemptamt,
                  RedemptionPercentage:RedemptionPercentage
                };
              }
          return item;
        })
      );
    }
    }
    else
    {
        setliquiditygriddt((prevData) =>
                prevData.map((item) => {        
                      if (item.InvestorTrackingId === params.data.InvestorTrackingId) {
                     
                    
                       
                        return {
                          ...item,
                          RedemptionAmount: redemptamt,
                        };
                      }
                  return item;
                })
              ); 
    }
}

    //const CheckboxRenderer = (props) => {
    //    const { value, data } = props;
    
    //    return (
    //        <input
    //            type="checkbox"
    //            disabled={data?.IsBooked} // Disable if booked
    //            defaultChecked={!data?.IsBooked} // Default checked if not booked
    //            onChange={() => console.log("Checkbox clicked", data)}
    //        />
    //    );
    //};
    


    const liqColDefs = [
        { headerName: 'Lot', field: "AssetLotName" },
        { headerName: 'Transaction Date', field: "RedemptionDate", valueFormatter: getFormattedDate ,editable: existingStatus?.InvestorTrackingStatusId!=9, valueFormatter: getFormattedDate ,  cellEditor: "agDateStringCellEditor" },
        ...(mode !== "Edit" ? [  {
            headerName: 'Available Amount', 
            field: "AvailableAmount", 
            cellStyle: { textAlign: "right" }, 
            cellRenderer: FormatCurrencyGrid 
        }] : []),
           {
            headerName: 'Redemption Amount', 
            field: "RedemptionAmount",
             editable: params => params.data?.IsBooked,
            cellStyle: { textAlign: "right" }, 
            cellRenderer: FormatCurrencyGrid,  
            onCellValueChanged: params => AmountchangeCalc(params) 
        },
        ...(mode !== "Edit" ? [   {
            headerName: 'Redemption Percent', 
            field: "RedemptionPercentage", 
             editable: params => params.data?.IsBooked,
            cellStyle: { textAlign: "right" }, 
            cellRenderer: FormatpercentCurrencyGrid,
           onCellValueChanged: params => percentchangeCalc(params)
            
        },
       
        {
            headerName: 'Add To Tracker',
                field: 'IsBooked',
                    minWidth: 75,
                        cellRenderer: CheckboxRendererMenu
            }
        ] : [])
    
    ];
    
    // Use getRowStyle for direct styling
    const getRowStyle = params => {
        if (params.data?.isadd) {
            return {
                fontStyle: "italic",
                backgroundColor: "#f0f0f0" // Light gray background for differentiation
            };
        }
        return null;
    };
    
    // Apply isRowSelectable to prevent selection of booked rows
    const isRowSelectable = params => !params.data?.isadd;
    //const isRowSelectable = params => console.log('params: ', params)

    

    const transColDefs = [
     //   {headerName: 'Lot', field: "lot"},
        {headerName: 'TransactionDate', field:"TransactionDate",valueFormatter:getFormattedDate},
        {headerName: 'Amount', headerClass: "text-end",field: "TransactionAmount",cellStyle: { textAlign:"right"},cellRenderer:FormatCurrencyGrid},
       // {headerName: 'Percent', field: "percent"},
        
    ];

    const fileColDefs = [
        {
            field: "fileName",
            headerName: "File Name",
            //cellRenderer: HyperlinkRenderer,
            sort: "asc",
            pinned: "left",
            minWidth: 442.47,
            floatingFilter: false,
            valueFormatter: gridValueFormatter,
            tooltipField: 'FileName',
            editable: true,
        },
        {
            headerName: "",
            field: "Delete",
            floatingFilter: false,
            minWidth: 442.47,
            cellRenderer: DeleteButtonRenderer,
        }
    ];
    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, flex: 1, resizable: true,
    }
    const getFamily = () => {
        sbaAxios({
          url: `${getAllFamilies}`,
          method: "get",
        }).then((response) => {
          setFamily(response);
        });
      };
      const getPortfoliosByFamilyId = async (Id) => {
        try {
            const list = await sbaAxios({
                url: getPortfoliosByFamily,
                params: {
                    familyId: Id
                }
            });
            setPortfolio(list);
           
        }
        catch (e) {
            setPortfolio([]);
           
        }
    };
    const getStatus = () => {
        sbaAxios({
          url: `${getInvestorStatus}`,
          method: "get",
        }).then((response) => {
            setStatus(response);
            if (mode !== "Edit") { setSelectedStatus(response[0]); }
        });
      };
      const getAssetsBytranstypeId = async (id,srchstring) => {
        try {
            const list =await sbaAxios({ url: `${getassetclassbyType}?portfolioId=${id}&transactionTypeId=4&searchString=${srchstring}` })
            setAsset(list);
        }
        catch (e) {
            setAsset([]);
           
        }
    };
    const getshareclassbyAssetId=async(Id)=>
    {
        try {
            const list =await sbaAxios({ url: `${getshareclassbyType}?portfolioId=${selectedPortfolio.EntityId}&assetId=${Id}&transactionTypeId=4` })
            setShareClass(list);
           
        }
        catch (e) {
            setShareClass([]);
           
        }
    }
  
    const getlots=async(assetId,portfolioId,shareclassid)=>
    {
        try {
            const res =await sbaAxios({ url: `${getAssetLotByPortfolio}${assetId},${portfolioId},${shareclassid}` })
           if(res.length>0)
           {
            setLot(res);
           
           }
           else
           {
            setLot();
            setSelectedLots([]);
           }
           
        }
        catch (e) {
            setLot([]);
            setSelectedLots([]);
           
        }
    };
    const assetcmbChange=(e)=>
    {
        if(e.value)
        {
        setSelectedAsset(e.value);
        setSelectedShareClass(null);
        getshareclassbyAssetId(e.value.AssetId);
       if(selectedShareClass && selectedPortfolio)
        getlots(selectedPortfolio.EntityId,e.value.AssetId,selectedShareClass.ShareClassId)
        }
    }
    const familycmbChange=(e)=>
    {

        if (e.value) {
            setSelectedFamily(e.value);
            setSelectedPortfolio([]);
            getPortfoliosByFamilyId(e.value.FamilyId);

            setSelectedAsset(null);
            setSelectedPortfolio(null);
            setSelectedShareClass(null);
            setAsset(val => []);
            setShareClass(val => []);

        }
      
    }
    const shareclasscmbChange=(e)=>
    {
        if(e.value)
        {
        setSelectedShareClass(e.value);
        getlots(selectedPortfolio.EntityId,selectedAsset.AssetId,e.value.ShareClassId)
        }
    }
    const getliquidityTransactiondata= async()=>
    {
        try {
            const res =await sbaAxios({ url: `${getInvestortrackersourcedata}?transactionTypeId=4&investorTrackingStatusId=${selectedStatus.InvestorTrackingStatusId}&familyId=${selectedFamily.FamilyId}&portfolioId=${selectedPortfolio.EntityId}&shareClassId=${selectedShareClass.ShareClassId}&assetId=${selectedAsset.AssetId}` })

            const Liquiditydata = res.Liquidity.map((item,index) => ({
                ...item,
                addbooked: item.IsBooked,
                IsBooked: !item.IsBooked,
                RowIndex: index 
            }));

            if (mode === "Edit") {
                setliquiditygriddt(Liquiditydata);
            }
            else{
                setliquiditygriddt(Liquiditydata);
                settransactiongriddt(res.Transactions)
            }
        }
        catch (e) {
            setLot([]);
            setSelectedLots([]);
        }
    }
    const AssetFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
          getAssetsBytranstypeId(selectedPortfolio.EntityId,terms);
        }
      };
    const saveRedemption = () => {
        if(selectedFamily.FamilyId  && selectedFamily.FamilyId && selectedPortfolio.EntityId && selectedShareClass.ShareClassId && selectedStatus.InvestorTrackingStatusId)
        {


            if (liquiditygriddt.some(item => !item.RedemptionDate)) {
                SBNotify({ Msg: "Please Select the Transaction Date", type: "error" });
                // saveSuccess = false;
                return;
            }
            if (selectedFiles.length > 0 && !selectedDocumentCategory?.ActivitySubTypeId) {
                SBNotify({ Msg: "Please Select the Document Category", type: "error" });
                return;
              }
              


            const TransactionItems = liquiditygriddt.filter(item => item.IsBooked && !item.isadd).map(item => ({
                "investorTrackingId": item.InvestorTrackingId || 0 ,
                "transactionDate": item.RedemptionDate,
                "familyId": selectedFamily.FamilyId,
                "portfolioId": selectedPortfolio.EntityId,
                "assetId": selectedAsset.AssetId,
                "shareClassId": selectedShareClass.ShareClassId,
                "assetLotId": item.AssetLotId,
                "investorTrackerStatusId": selectedStatus.InvestorTrackingStatusId,
                "transactionTypeId": 4,
                "transactionGroupId": groupId || 0,
                "transactionAmount": item?.RedemptionAmount,
                "transactionPercentage": item?.RedemptionPercentage,
                "activityId": 0,
                "notes": note
            }));
            const DocumentItems=selectedFiles.map(item=>(
                {
                    "documentId": item.documentId,
                    "documentName": item.fileName,
                    "documentContent": item?.base64String ||"",
                    "documentExtension":'pdf'
                }
            ))
            const DataTOSave={
                "transactions": TransactionItems,
                "documents":DocumentItems,
                "ActvitySubTypeId": selectedFiles.length === 0 ? 0 : selectedDocumentCategory.ActivitySubTypeId
              };
            sbaAxios({url:insertorupdateInvestorTracking , data:DataTOSave ,method:'post'}).then(res=>{
                navigate(UrlPath.InvestorTracking);

                setTimeout(() => {
                    if (params?.InvestorTrackingId == 0)
                        SBNotify({ Msg: "Redemption Added Successfully" });
                    else
                        SBNotify({ Msg: "Redemption Updated Successfully" });
                }, 10);

            }).catch(error=>{
                SBNotify({Msg:"Error Occured While Saving the Redemption", type:"error"});
            });
        }
    };
    const clearAll=()=>{
        setSelectedAsset(null);
        setSelectedFamily(null);
        setSelectedPortfolio(null);
        setSelectedShareClass(null);
        setliquiditygriddt([]);
        setSelectedFiles([]);
        settransactiongriddt([]);
    };
    console.log(selectedFiles,'selectedFiles')
    return(
        <>
        <TopBar label={"Investor Tracking - Redeem"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4">
                <div className="row">
                    <div className="detail p-4">
                        <div className="row">
                            <div className="col-4">
                                <label className="label">Family <span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                            className="w-75"
                                            data={family}
                                            textField={"FamilyName"}
                                            valueField={"FamilyId"}
                                            value={selectedFamily}
                                            onChange={familycmbChange}
                                            popupSettings={{ className: "modalDD" }}
                                            disabled={ mode === "Edit"}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Portfolio <span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={portfolio}
                                        textField={"EntityName"}
                                        valueField={"EntityId"}
                                        value={selectedPortfolio}
                                        onChange={(e) => setSelectedPortfolio(e.value)}
                                         popupSettings={{ className: "modalDD" }}
                                         disabled={mode === "Edit"}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Status <span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={status}
                                        textField={"InvestorTRackingStatusName"}
                                        valueField={"InvestorTrackingStatusId"}
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.value)}
                                        popupSettings={{ className: "modalDD" }}
                                    ></SBAComboBox>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                        <div className="col-4">
                            <label className="label">Asset <span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={asset}
                                        textField={"AssetName"}
                                        valueField={"AssetId"}
                                        value={selectedAsset}
                                        onChange={assetcmbChange}
                                        onFilterChange={AssetFilterChange}
                                            popupSettings={{ className: "modalDD" }}
                                            disabled={mode === "Edit"}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Invested Share Class <span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={shareClass}
                                        textField={"ShareClassName"}
                                       valueField={"ShareClassId"}
                                        value={selectedShareClass}
                                        onChange={shareclasscmbChange}
                                            popupSettings={{ className: "modalDD" }}
                                            disabled={mode === "Edit"}
                                    ></SBAComboBox>
                                </div>
                            </div>
                          
                           
                        </div>
                        <div className="row  mt-2">
                            <div className="col-2 ms-auto gap-2 d-flex" >
                                    {mode !== "Edit" ? (
                                        <>
                                        <button
                                        type="submit"
                                        className="s-sm-btn ms-auto"
                                        onClick={()=>{clearAll()}}
                                    >
                                        Clear All
                                    </button>
                            <button
                                        type="submit"
                                        className="p-sm-btn "
                                        onClick={getliquidityTransactiondata}
                                    >
                                                Go
                                    </button>
                                        </>
                                    ) : null}
                            
                            </div>
                        
                        </div>
                    </div>
                </div>
                    <div className="row d-flex mt-2">
                        <div className="col-6 p-2">
                            <label className="mb-1 label">Liquidity</label>
                            <div className="ag-theme-alpine" style={{ height: "300px", width: "100%", paddingTop: 0 }}>
                                <AgGridReact
                                    rowData={liquiditygriddt}
                                    columnDefs={liqColDefs}
                                    getRowStyle={getRowStyle}
                                    isRowSelectable={isRowSelectable}
                                    defaultColDef={{ resizable: true, sortable: true, filter: true, flex: 1 }}
                                    rowSelection="single"
                                />
                            </div>
                        </div>
                        <div className="col-6 p-2">
                            <label className="mb-1 label">{mode === "Edit"? 'Booked Transactions': 'Existing Transactions'}</label>
                            <div className="ag-theme-alpine" style={{ height: "300px", width: "100%", paddingTop: 0 }}>
                                <AgGridReact
                                    rowData={transactiongriddt}
                                    columnDefs={transColDefs}
                                    defaultColDef={{ resizable: true, sortable: true, filter: true, flex: 1 }}
                                    rowSelection="single"
                                />
                            </div>
                        </div>
                    
                </div>
                
                <div className="row mt-2">

                <div className="col-6">
                        <div className="row">
                        <label className="mb-1 label">Upload Files : (PDF Only)</label>
                            <div className="mt-2" style={{ position: "relative" }}>
                                <input
                                    type="file"
                                    id="fileInput"
                                    className="input-hidden"
                                    onChange={handleFileChange}
                                />
                                {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                            </div>
                        </div>

                        <div className="row mt-2">
  <label className="label">Document Category<span className="mandatory">*</span></label>
  <div>
    <SBAComboBox
      className="w-50"
      data={documentCategories}
      textField={"ActivitySubType"}
      valueField={"ActivitySubTypeId"}
      value={selectedDocumentCategory}
      onChange={(e) => setSelectedDocumentCategory(e.value)}
      popupSettings={{ className: "modalDD" }}
      disabled={selectedFiles.length === 0}
    />
  </div>
</div>

                        <div className="row mt-2">
                            <div className="ag-theme-alpine" style={{ width: '100%', height: '300px' }}>
                                <AgGridReact
                                    columnDefs={fileColDefs}
                                    rowData={selectedFiles}
                                    defaultColDef={defaultColDef}
                                    // domLayout= {'autoHeight'}
                                    onCellValueChanged={onCellValueChanged}
                                    overlayNoRowsTemplate={`<span>${'No data Available'}</span>`}
                                    ref={gridRef}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                    </div>

                    <div className="col-6" style={{marginTop:'52px'}}>
                        <label className="mb-1 label">Note</label>
                        <div>
                            <textarea
                            className="form-control"
                            type="text"
                            name="note"
                            onChange={(e) => setNote(e.target.value)}
                            defaultValue={note}
                            style={{height: '280px'}}
                            />
                        </div>
                    </div>
                   
                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                    <button className="s-sm-btn" onClick={()=>{navigate(UrlPath.InvestorTracking)}}>
                        Cancel
                    </button>
                    <button className="p-sm-btn" onClick={()=>{saveRedemption()}} 
disabled={existingStatus?.InvestorTrackingStatusId==9}>
                    {mode === "Edit" ? "Update" : "Add To Tracker"}
                    </button>
                </div>
            </div>
        </div>
        <ToastContainer/>
        </>
    );
}

const styles = `
    .booked-row {
        font-style: italic;
        background-color: #f0f0f0; /* Light gray background for differentiation */
    }
`;

// Append styles dynamically
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);